export default "__VITE_ASSET__f145b350__"